import React from 'react';
import { classnames } from '../../../utils/classnames';
import { PhysiqueLoginService } from '../login-service';
import useMobileResize from '../../../hooks/useMobileResize';
import { clearLocalPhysiqueStorage, TOKEN_TYPE } from '../../../utils/auth';

export default function LoginWidget() {
  const access_token = localStorage.getItem(TOKEN_TYPE.PHYSIQUE_ACCESS);
  const fullName = localStorage.getItem('fullname');
  const membershipImage = localStorage.getItem('membershipImage');
  const userIconSettings = {
    width: isMobile ? 21 : 16,
    height: isMobile ? 22 : 17,
  };
  const isMobile = useMobileResize();

  const handleClickLogout = () => {
    PhysiqueLoginService.logout().then(() => {
      clearLocalPhysiqueStorage();
      window.location = window.location.origin + '/';
    });
  };

  const userIcon = <UserIcon width={userIconSettings.width} height={userIconSettings.height} />;

  if (access_token) {
    return (
      <div className={classnames('login-widget__profile', isMobile && 'login-widget__profile_mobile')}>
        <a href="/profile" className="login-widget__link tpg_buttons">
          {userIcon}
          <span className="login-widget__name tpg_buttons">{fullName}</span>
          {membershipImage && (
            <picture className="login-widget__membership">
              <img src={membershipImage} alt="membership" />
            </picture>
          )}
        </a>
        {isMobile ? (
          <LogoutIcon onClick={handleClickLogout} />
        ) : (
          <>
            <div className="login-widget__separator"></div>
            <button className="login-widget__logout tpg_buttons" onClick={handleClickLogout}>
              Logout
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div className={classnames('login-widget__module', isMobile ? 'login-widget__module_mobile' : '')}>
      {userIcon}
      <a href="/login" className="tpg_buttons">
        Patient Login
      </a>
      <span>/</span>
      <a href="/sign-up" className="tpg_buttons">
        Sign Up
      </a>
    </div>
  );
}

function LogoutIcon({ onClick }) {
  return (
    <svg
      className="icon logout-icon"
      onClick={onClick}
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14.5V17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3.063M8 10h10m0 0-2.5-2.5M18 10l-2.5 2.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UserIcon({ width, height }) {
  return (
    <svg className="icon" width={width} height={height} viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 9.58a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5ZM3.333 14.996v-1.362a4.317 4.317 0 0 1 2.625-3.971m6.709 5.333v-1.362a4.317 4.317 0 0 0-2.625-3.971" />
    </svg>
  );
}
